class TimeSeries {

	/**
	 * Set a user-specified time interval and output format,
	 * initialise a date (24 hours) to act as parameters
	 * and an empty array into which times are added.
	 */
	constructor({interval = 30, locale = 'en-UK', options} = {}) {
		this.int = interval
		this.loc = locale
		this.opts = options

		this.dt = new Date(1970, 0, 1)
		this.series = []

		this.run()

		return this.series
	}

	/**
	 * Returns formatted time string, replacing
	 * every instance of hour "24" with "00".
	 */
	formatTimeString(time) {
		const regex24hr = /^(24)/i
		return time.toLocaleTimeString(this.loc, this.opts).replace(regex24hr, '00')
	}

	/**
	 * Run the loop as long as the date is the 1st,
	 * append the most recent value to the array
	 * then increase the time by the interval.
	 */
	run() {
		while (this.dt.getDate() === 1) {
			let timeStr = this.formatTimeString(this.dt)
			this.series.push(timeStr)
			this.dt.setMinutes(this.dt.getMinutes() + this.int)
		}
	}
}

export default TimeSeries
